import { required } from "@vuelidate/validators";
export default class Operator {
  constructor() {
    this.id = null;
    this.status = true;
    this.person = null;
    this.url = null;
  }
  validations() {
    return {
      status: {
        required,
      },
    };
  }
  getData(data) {
    this.id = data.id;
    this.status = data.status;
    this.person = data.person;
    this.url = data.url;
  }
  toJson() {
    return {
      id: this.id,
      person: this.person,
      status: this.status,
      url: this.url,
    };
  }
}
